import SheetModal from "@/components/ui/sheet-modal";
import ShareButtons from "@/components/views/modals/ShareButtons";

interface SharePageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SharePageModal(props: SharePageModalProps) {
  return (
    <SheetModal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="flex items-center justify-center py-2">
        <span className="text-rose-500 text-xl font-bold font-['DM Sans']">
          Bu sayfayı paylaşın
        </span>
      </div>

      <ShareButtons type={1} />
    </SheetModal>
  );
}
